var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wangEditor"},[(_vm.showEditor)?_c('div',{ref:"editor",attrs:{"placeholder":"请输入内容"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }